var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"closable":false,"title":_vm.modalTitle},on:{"on-ok":_vm.ok},model:{value:(_vm.isShowModal),callback:function ($$v) {_vm.isShowModal=$$v},expression:"isShowModal"}},[_c('div',{staticStyle:{"margin":"25px"}},[_vm._v(_vm._s(_vm.modalBody))])])
}
var staticRenderFns = []

export { render, staticRenderFns }